import React, {useCallback, useContext, useEffect, useReducer, useRef, useState} from 'react';
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {useHistory} from "react-router-dom";
import useGetAllTicket from "../../../ticket/utils/useGetAllTicket";
import {onClickDetails} from "../../../../../services/AutomationServices";
import {
	AUTOMATION_INITIAL_STATE,
	AutomationReducer,
	initAutomationState
} from "../../../../../reducers/AutomationReducer";
import {getAccountInfo} from "../../../../../utils/GenericUtils";
import {getAnagraficaById} from "../../../../../services/AnagraficaServices";
import {setOpenSnackbar} from "../../../../../services/AppServices";
import {AnagraficaContext, AppContext} from "../../../../../App";
import {Card, CardContent, CardHeader} from "@mui/material";
import clsx from "clsx";
import TicketCard from "../../../ticket/details/TicketCard";
import { Alert, AlertTitle, Skeleton } from '@mui/material';

const TicketSection = ({idSoggetto}) => {
	const classes = BaseStyle();
	const history = useHistory();
	const anagraficaContext = useContext(AnagraficaContext);
	const appContext = useContext(AppContext);
	const [pageNumber, setPageNumber] = useState(0);
	const [selected, setSelected] = useState({});
	const [automationState, automationDispatch] = useReducer(AutomationReducer, AUTOMATION_INITIAL_STATE, initAutomationState);
	const {
		loading,
		error,
		hasMore,
		tickets
	} = useGetAllTicket("", "", pageNumber, idSoggetto, null, "dataUltimaModifica", "ASC")
	const observer = useRef();
	
	const lastTicketElementRef = useCallback(node => {
		if (loading) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMore) {
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [loading, hasMore])
	
	const handleTicketSelect = useCallback((ticket) => {
		setSelected(ticket);
		onClickDetails(ticket.id, "ticket", "modify", automationDispatch);
	}, [automationDispatch]);
	
	useEffect(() => {
		if (!automationState.loadingOnClick && automationState.errorOnClick === "") {
			if (automationState.operatorOnClick.replace("ERR_", "").includes(getAccountInfo().alias)) {
				getAnagraficaById(selected.idSoggetto, anagraficaContext.dispatch)
				history.push("/gestione/tickets/" + selected.id);
			} else {
				setOpenSnackbar("warning", ("Il ticket è al momento gestito da " + automationState.operatorOnClick?.replace("ERR_", "") + ". Ritenta e sari più fortunato :)"), appContext.dispatch)
			}
		}
	}, [automationState.loadingOnClick, automationState.errorOnClick, automationState.operatorOnClick, selected,
		anagraficaContext.dispatch, history, appContext.dispatch])
	
	
	return (
        <React.Fragment>
            {
				loading &&
				<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
					<CardHeader
						avatar={<Skeleton variant="circular" height={40} width={40}/>}
						title={<Skeleton width={180}/>}
						subheader={<Skeleton width={260}/>}
						action={<Skeleton variant="circular" height={20} width={20}/>}
						style={{paddingBottom: 2}}
					/>
					<CardContent style={{paddingTop: 0, marginTop: -35}}>
						<Skeleton height={200}/>
					</CardContent>
				</Card>
			}
            {
				error && <Alert severity="error" style={{borderRadius: 24}}>
					<AlertTitle>Errore</AlertTitle>
					Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
					sviluppatori.
				</Alert>
			}
            {
				tickets.map((ticket, index) => {
					if (tickets.length === index + 1) {
						return (
							<Card ref={lastTicketElementRef} key={ticket.id}
							      className={clsx(classes.roundBorder, classes.mailCard)}>
								<TicketCard ticket={ticket} setValue={() => alert("non supportato qui")}
								            handleTicketSelect={handleTicketSelect}/>
							</Card>
						)
					} else {
						return (
							<Card key={ticket.id} className={clsx(classes.roundBorder, classes.mailCard)}>
								<TicketCard ticket={ticket} setValue={() => alert("non supportato qui")}
								            handleTicketSelect={handleTicketSelect}/>
							</Card>
						)
					}
				})
			}
            {!loading && !error && tickets.length === 0 &&
				<Alert severity="info" style={{borderRadius: 24}}>
					<AlertTitle>Evvai 😇!!</AlertTitle>
					Non ci sono ticket! Goditi questo meritato relax
				</Alert>}
        </React.Fragment>
    );
}

export default React.memo(TicketSection);
